import { ActionStatus, buildActionType } from '../core';
import { CONFIRM_REGISTER_BIZ } from '../types';

const confirmRegisterBiz = (
  state = {
    items: [],
    loading: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case buildActionType(CONFIRM_REGISTER_BIZ, ActionStatus.START):
      return { loading: true, items: [], error: null };

    case buildActionType(CONFIRM_REGISTER_BIZ, ActionStatus.DONE):
      return { loading: false, items: action.payload, error: null };

    case buildActionType(CONFIRM_REGISTER_BIZ, ActionStatus.FAILED):
      return { loading: false, items: [], error: action.payload };

    default:
      return state;
  }
};

export { confirmRegisterBiz };
